// removed by extract-text-webpack-plugin
module.exports = {"titleContainer":"_8yyOS","container":"_2gJZC","icon":"AT10m","title":"_3j86f","content":"_2qimT"};


//////////////////
// WEBPACK FOOTER
// ./app/components/confirmation/confirmation.scss
// module id = 634
// module chunks = 3 4 5 6 7